import { render, staticRenderFns } from "./saleAddGroup.vue?vue&type=template&id=2f85b1d6&scoped=true&"
import script from "./saleAddGroup.vue?vue&type=script&lang=js&"
export * from "./saleAddGroup.vue?vue&type=script&lang=js&"
import style0 from "./saleAddGroup.vue?vue&type=style&index=0&id=2f85b1d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85b1d6",
  null
  
)

export default component.exports